import { onBeforeUnmount } from "vue";

export function useEventBusWatch() {
  const watchInstances: (() => void)[] = [];

  function trackWatch(watchInstance: () => void) {
    watchInstances.push(watchInstance);
  }

  onBeforeUnmount(() => {
    watchInstances.forEach((watchInstance) => {
      if (typeof watchInstance === "function") {
        watchInstance();
      }
    });
  });

  return {
    trackWatch,
  };
}
